import axiosInstance from '@/lib/axios'; // Your configured axiosInstance instance



import { jwtDecode } from 'jwt-decode';


export async function getCurrentUserIdFromToken() {
  const token = localStorage.getItem("authToken"); // or wherever you store it
  if (!token) return null;
  try {

    const decoded = jwtDecode(token);


    return decoded.sub;

    //return decoded.user_id || decoded.sub || null;  // depends on your token claims
  } catch (e) {
    console.error("Failed to decode token", e);
    return null;
  }
}




export async function getCurrentUserInfo() {

  const response = await axiosInstance.get('/users/me');
  return response.data;

}




export async function getMatchStatusPing() {

  const response = await axiosInstance.get('/match/status/is_found');
  return response;

}




export async function getUserPreferences() {
  const response = await axiosInstance.get("/users/preferences");
  const data = response.data;
  const isValid =
    data &&
    (data.sport_id !== null &&
      data.sport_name !== null &&
      data.location !== null &&
      data.game_type !== null &&
      data.player !== null);

  return isValid ? data : false;
}



export async function updateUserPreferences(preferences) {


  const token = localStorage.getItem("authToken");
  const tokenType = localStorage.getItem("tokenType");

  if (!token || !tokenType) {
    throw new Error("Unauthorized. Please log in.");
  }

  try {
    const response = await axiosInstance.patch("/users/preferences", preferences, {
      headers: {
        Authorization: `${tokenType} ${token}`,
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.removeItem("authToken");
      localStorage.removeItem("tokenType");
      throw new Error("Unauthorized. Authentication Expired");
    }
    throw error;
  }
}



export async function fetchFriends() {
  const token = localStorage.getItem("authToken");
  const tokenType = localStorage.getItem("tokenType");

  if (!token || !tokenType) {
    throw new Error("Unauthorized. Please log in.");
  }

  try {
    const response = await axiosInstance.get("/users/friends/me", {
      headers: {
        Authorization: `${tokenType} ${token}`,
      },
    });


    return response.data;

  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.removeItem("authToken");
      localStorage.removeItem("tokenType");
      throw new Error("Unauthorized. Authentication Expired");
    } else if (error.response?.status === 404) {
      return []; // No friends found
    }
    throw error;
  }
}




export async function initiateMatchQueue() {
  const token = localStorage.getItem("authToken");
  const tokenType = localStorage.getItem("tokenType");

  if (!token || !tokenType) {
    throw new Error("Unauthorized. Please log in.");
  }

  try {
    const response = await axiosInstance.post("/match/queue", {
      headers: {
        Authorization: `${tokenType} ${token}`,
      },
    });


    return response.data;

  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.removeItem("authToken");
      localStorage.removeItem("tokenType");
      throw new Error("Unauthorized. Authentication Expired");
    } else if (error.response?.status === 404) {
      return []; // No friends found
    }
    throw error;
  }
}




export async function cancelMatchQueue() {
  const token = localStorage.getItem("authToken");
  const tokenType = localStorage.getItem("tokenType");

  if (!token || !tokenType) {
    throw new Error("Unauthorized. Please log in.");
  }

  try {
    const response = await axiosInstance.delete("/match/queue", {
      headers: {
        Authorization: `${tokenType} ${token}`,
      },
    });
    console.log(response.data)

    return response.data;

  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.removeItem("authToken");
      localStorage.removeItem("tokenType");
      throw new Error("Unauthorized. Authentication Expired");
    } else if (error.response?.status === 404) {
      return []; // No friends found
    }
    throw error;
  }
}




export async function fetchMatchQueue() {
  const token = localStorage.getItem("authToken");
  const tokenType = localStorage.getItem("tokenType");

  if (!token || !tokenType) {
    throw new Error("Unauthorized. Please log in.");
  }

  try {
    const response = await axiosInstance.get("/match/queue", {
      headers: {
        Authorization: `${tokenType} ${token}`,
      },
    });


    return response.data;

  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.removeItem("authToken");
      localStorage.removeItem("tokenType");
      throw new Error("Unauthorized. Authentication Expired");
    } else if (error.response?.status === 404) {
      return []; // No friends found
    }
    throw error;
  }
}





/**
 * Fetch active matches for the logged-in user.
 * Optionally filters by team size (e.g. "1v1", "2v2", ..., "6v6").
 *
 * @param {string} [teamSize] - Optional team size filter ("1v1" to "6v6").
 * @returns {Promise<Array>} List of active matches.
 * @throws {Error} If unauthorized or request fails.
 */



export async function fetchActivateMatch(teamSize) {
  const token = localStorage.getItem('authToken');
  const tokenType = localStorage.getItem('tokenType');

  if (!token || !tokenType) {
    throw new Error('Unauthorized. Please log in.');
  }

  try {
    const response = await axiosInstance.get('/users/me/matches', {
      headers: {
        Authorization: `${tokenType} ${token}`,
      },
      params: teamSize ? { team_size: teamSize } : {},
    });

    return response.data;

  } catch (error) {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('authToken');
      localStorage.removeItem('tokenType');
      throw new Error('Unauthorized. Authentication Expired');
    }
    throw error;
  }
}





export async function fetchInMatchAppointmentsMatch(in_match_id) {
  const response = await axiosInstance.get(`/match/appointments/${in_match_id}`);

  // no content
  if (response.status == 204) {

    return false
  }

  return response.data;
}





// invite lobby if 2v2 or etc

export async function post_inv_friends_mylobby(invited_user) {
  const token = localStorage.getItem("authToken");
  const tokenType = localStorage.getItem("tokenType");

  if (!token || !tokenType) {
    throw new Error("Unauthorized. Please log in.");
  }
  try {
    const response = await axiosInstance.post(
      "/match/invite",
      { invited_user }, // body
      {
        headers: {
          Authorization: `${tokenType} ${token}`,
        },
      }
    );

    return response.data;

  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.removeItem("authToken");
      localStorage.removeItem("tokenType");
      throw new Error("Unauthorized. Authentication Expired");
    } else if (error.response?.status === 404) {
      return []; // No friends found
    }
    throw error;
  }
}



export async function delete_inv_friends_mylobby(invited_user) {
  const token = localStorage.getItem("authToken");
  const tokenType = localStorage.getItem("tokenType");

  if (!token || !tokenType) {
    throw new Error("Unauthorized. Please log in.");
  }
  try {
    const response = await axiosInstance.delete(
      "/match/invite",
      {
        data: { invited_user }, // correct way to send body with DELETE
        headers: {
          Authorization: `${tokenType} ${token}`,
        },
      }
    );

    return response.data;

  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.removeItem("authToken");
      localStorage.removeItem("tokenType");
      throw new Error("Unauthorized. Authentication Expired");
    } else if (error.response?.status === 404) {
      return []; // No friends found
    }
    throw error;
  }
}




export async function post_create_lobby() {
  const response = await axiosInstance.post("/match/lobby", {}); // no payload
  console.log(response.data);
  return response.data;
}


export async function leave_lobby_or_delete() {
  const response = await axiosInstance.delete("/match/lobby");
  console.log(response.data);
  return response.data;
}





// create lobby if 2v2 or etc
export async function fetch_lobby_info() {
  const token = localStorage.getItem("authToken");
  const tokenType = localStorage.getItem("tokenType");

  if (!token || !tokenType) {
    throw new Error("Unauthorized. Please log in.");
  }

  try {
    const response = await axiosInstance.get(
      "/match/lobby",

      {
        headers: {
          Authorization: `${tokenType} ${token}`,
        },
      }
    );

    return response.data;

  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.removeItem("authToken");
      localStorage.removeItem("tokenType");
      throw new Error("Unauthorized. Authentication Expired");
    } else if (error.response?.status === 404) {
      return []; // No friends found
    }
    throw error;
  }
}





export async function fetch_myfriends_invites() {
  const token = localStorage.getItem("authToken");
  const tokenType = localStorage.getItem("tokenType");

  if (!token || !tokenType) {
    throw new Error("Unauthorized. Please log in.");
  }

  try {
    const response = await axiosInstance.get("/users/friends/me/invite", {
      headers: {
        Authorization: `${tokenType} ${token}`,
      },
    });


    return response.data;

  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.removeItem("authToken");
      localStorage.removeItem("tokenType");
      throw new Error("Unauthorized. Authentication Expired");
    } else if (error.response?.status === 404) {
      return []; // No friends found
    }
    throw error;
  }
}






export async function fetch_match_invites() {
  const token = localStorage.getItem("authToken");
  const tokenType = localStorage.getItem("tokenType");

  if (!token || !tokenType) {
    throw new Error("Unauthorized. Please log in.");
  }

  try {
    const response = await axiosInstance.get("/match/notification/invite", {
      headers: {
        Authorization: `${tokenType} ${token}`,
      },
    });


    return response.data;

  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.removeItem("authToken");
      localStorage.removeItem("tokenType");
      throw new Error("Unauthorized. Authentication Expired");
    } else if (error.response?.status === 404) {
      return []; // No friends found
    }
    throw error;
  }
}





export async function post_get_evaluated_invite(invite_id) {
  const token = localStorage.getItem("authToken");
  const tokenType = localStorage.getItem("tokenType");

  if (!token || !tokenType) {
    throw new Error("Unauthorized. Please log in.");
  }

  try {
    const response = await axiosInstance.post(
      "/match/notification/invite/evaluate",
      { invite_id }, // body
      {
        headers: {
          Authorization: `${tokenType} ${token}`,
        },
      }
    );

    console.log(response.data)
    return response.data;

  } catch (error) {
    if (error.response) {
      const { status, data } = error.response;

      if (status === 401) {
        localStorage.removeItem("authToken");
        localStorage.removeItem("tokenType");
        throw new Error("Unauthorized. Authentication Expired");
      } else if (status === 404) {
        return []; // No friends found
      } else if (data?.detail) {
        // This is the FastAPI error detail
        throw new Error(data.detail);
      }
    }
    throw error;
  }
}





export async function createGroupMessagesContent(group_id, content) {
  const token = localStorage.getItem("authToken");
  const tokenType = localStorage.getItem("tokenType");

  if (!token || !tokenType) {
    throw new Error("Unauthorized. Please log in.");
  }

  try {
    const response = await axiosInstance.post(
      `/match/in_match_chat/`,
      { group_id, content }, // body with group_id and content
      {
        headers: {
          Authorization: `${tokenType} ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.removeItem("authToken");
      localStorage.removeItem("tokenType");
      throw new Error("Unauthorized. Authentication Expired");
    }
    throw error;
  }
}





export async function sendFriendRequest(receiver_id) {



  const response = await axiosInstance.post(
    `/users/friends/`,
    { receiver_id },


  );


  return {
    success: true,
    data: response.data,
    message: "Friend request sent successfully."
  };

}




export async function sendMatchResult(match_id, result) {
  const token = localStorage.getItem("authToken");
  const tokenType = localStorage.getItem("tokenType");

  console.log(match_id, result)

  if (!token || !tokenType) {
    throw new Error("Unauthorized. Please log in.");
  }

  try {
    const response = await axiosInstance.patch(
      `/match/status`,
      { match_id, result },
      {
        headers: {
          Authorization: `${tokenType} ${token}`,
        },
      }
    );

    return {
      success: true,
      data: response.data,
      message: "Friend request sent successfully."
    };
  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.removeItem("authToken");
      localStorage.removeItem("tokenType");
      throw new Error("Unauthorized. Authentication expired.");
    }

    if (error.response?.data?.detail) {
      throw new Error(error.response.data.detail);
    }

    throw new Error("Failed to send friend request. Please try again.");
  }
}



export async function cancelMatch(match_id) {



  const response = await axiosInstance.patch(
    `/match/status/cancel`,
    { match_id },


  );

  return response.data



}






export async function submitReportMatch(match_id, content) {
  const token = localStorage.getItem("authToken");
  const tokenType = localStorage.getItem("tokenType");

  if (!token || !tokenType) {
    throw new Error("Unauthorized. Please log in.");
  }


  try {
    const response = await axiosInstance.post(
      `/report/match`,
      { match_id, content },
      {
        headers: {
          Authorization: `${tokenType} ${token}`,
        },
      }
    );

    return {
      success: true,
      data: response.data,
      message: "Report submitted successfully."
    };
  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.removeItem("authToken");
      localStorage.removeItem("tokenType");
      throw new Error("Unauthorized. Authentication expired.");
    }

    if (error.response?.data?.detail) {
      throw new Error(error.response.data.detail);
    }

    throw new Error("Failed to submit report. Please try again.");
  }
}







export async function submitReportUsers(match_id, target_user_id, content) {
  const token = localStorage.getItem("authToken");
  const tokenType = localStorage.getItem("tokenType");


  if (!token || !tokenType) {
    throw new Error("Unauthorized. Please log in.");
  }



  try {
    const response = await axiosInstance.post(
      `/report/users`,
      { match_id, content, target_user_id },
      {
        headers: {
          Authorization: `${tokenType} ${token}`,
        },
      }
    );

    return {
      success: true,
      data: response.data,
      message: "Report submitted successfully."
    };
  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.removeItem("authToken");
      localStorage.removeItem("tokenType");
      throw new Error("Unauthorized. Authentication expired.");
    }

    if (error.response?.data?.detail) {
      throw new Error(error.response.data.detail);
    }

    throw new Error("Failed to submit report. Please try again.");
  }
}



export async function submitRateUsers(match_id, rated_user_id, rating) {
  const token = localStorage.getItem("authToken");
  const tokenType = localStorage.getItem("tokenType");


  if (!token || !tokenType) {
    throw new Error("Unauthorized. Please log in.");
  }



  try {
    const response = await axiosInstance.post(
      `/user_ratings/`,
      { match_id, rated_user_id, rating },
      {
        headers: {
          Authorization: `${tokenType} ${token}`,
        },
      }
    );

    return {
      success: true,
      data: response.data,
      message: "Rate submitted successfully."
    };
  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.removeItem("authToken");
      localStorage.removeItem("tokenType");
      throw new Error("Unauthorized. Authentication expired.");
    }

    if (error.response?.data?.detail) {
      throw new Error(error.response.data.detail);
    }

    throw new Error("Failed to submit rate. Please try again.");
  }
}



















export async function sendAppointment(payload) {

  const res = await axiosInstance.post('/appointments/in_match_chat', payload);
  return res.data;


}

export async function fetchConversationAppointment(in_match_id) {


  try {


    const res = await axiosInstance.get(`/appointments/in_match_chat/${in_match_id}`);
    return res.data;
  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.removeItem('authToken');
      localStorage.removeItem('tokenType');
      throw new Error('Unauthorized. Authentication expired.');
    }

    throw new Error('Failed to fetch conversation appointments');
  }
}





export async function getLobbyDetailsFromInvite() {
  const response = await axiosInstance.get("/match/lobby/active_invite_lobby"); // no payload
  console.log(response.data);
  return response.data;
}





export async function updateInMatchchatGroupName(group_name, group_id) {


  const res = await axiosInstance.patch(`/match/in_match_chat/${group_id}`, group_name);

  return res.data;
}


export async function fetchGroupMessagesContent(group_id, page) {


  const response = await axiosInstance.get(`/match/in_match_chat/${group_id}`, {
    params: { page } // send the page as query param
  });
  return response.data;
}





export async function sendAppointmentInMatchChat(payload) {
  const res = await axiosInstance.post('/appointments/in_match_chat', payload);
  return res.data;

}


export async function fetchGroupAppointment(in_match_id) {


  try {


    const res = await axiosInstance.get(`/appointments/in_match_chat/${in_match_id}`);
    return res.data;
  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.removeItem('authToken');
      localStorage.removeItem('tokenType');
      throw new Error('Unauthorized. Authentication expired.');
    }

    throw new Error('Failed to fetch conversation appointments');
  }
}
